import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '@/app/core/services/auth.service';

function extractLpOrg(url: string): string | null {
  const match = url.match(/^\/lp\/([^/]+)/);
  return match ? match[1] : null;
}

export const authGuard: CanActivateFn = (_, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isLoggedIn()) return true;
  const org = extractLpOrg(state.url);
  if (org) {
    router.navigate(['/lp', org, 'login'], {
      queryParams: {returnUrl: state.url},
    });
  } else {
    router.navigate(['/auth/login'], {queryParams: {returnUrl: state.url}});
  }
  return false;
};
